var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsChangedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings_suggest_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 5 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(1.82 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M20.325,18.081l2.49,1.911-3.208,5.629L16.732,24.4a8.535,8.535,0,0,1-.821.481L15.525,28H9.109l-.385-3.133a7.53,7.53,0,0,1-.821-.481L5.028,25.608,1.82,19.979l2.49-1.911C4.3,17.925,4.3,17.756,4.3,17.6s0-.325.013-.481L1.82,15.208,5.028,9.579,7.9,10.8a8.535,8.535,0,0,1,.821-.481L9.109,7.2h6.416l.385,3.133a7.53,7.53,0,0,1,.821.481l2.875-1.222,3.208,5.629-2.49,1.911c.013.156.013.312.013.481S20.338,17.925,20.325,18.081ZM16.167,17.6a3.85,3.85,0,1,0-3.85,3.9A3.87,3.87,0,0,0,16.167,17.6Z",
    transform: "translate(-1.82 -2)",
    fill: "#62b0dc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsChangedIcon);
export default __webpack_public_path__ + "static/media/SettingsChangedIcon.716706b5bf9bc58f4013635e47c3527d.svg";
export { ForwardRef as ReactComponent };